<template>
  <nav>
    <v-app-bar id="AppBar" class="app-bar" app>
      <v-app-bar-nav-icon color="#555" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <c-btn text iconName="home" iconColor="dark3Grey"> {{ userInfo.centerName }}</c-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <c-btn text v-on="on" iconName="person" iconColor="dark3Grey">
            {{ userInfo.loginId }}
          </c-btn>
        </template>
        <v-list flat>
          <v-list-item active-class="border" @click="logout">
            <v-icon color="dark3Grey"> mdi-logout</v-icon>
            <v-list-item-title> 로그아웃</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app class="app-navibar">
      <div class="app-menu-logo">
        <div class="namuMint--text font-weight-bold" style="font-size: 20px;">관리자 시스템</div>
        <div class="namuMint--text" style="font-size: 14px;"> ver.{{productVersion}}</div>
        <!--<img src="../assets/autocrypt_MI_logo_white.png" alt="AutoCrypt-Logo" style="height: 38px;"/>-->
      </div>
      <div>
        <div class="list-item-group">
          <v-list dark expand>
            <template v-for="route in routes">
              <v-list-item v-if="route.type === 'menu'" active-class="border"
                           @click="navClick(route)" :key="route.name">
                <!--<v-icon class="mr-4 app-menu-item-icon">{{route.icon}}</v-icon>-->
                <v-list-item-content>
                  <v-list-item-title class="app-menu-item-text pl-5">{{route.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group
                v-else-if="(route.type === 'category')"
                :key="route.name"
                color="namuMint"
                v-model="route.active"
                :class="menuDisplayWithRole(route)"
                active-class="app-menu-group-item"
              >
                <template v-slot:activator >
                  <!--Categoty 아이콘 제거-->
                  <!--<v-icon class="mr-4 app-menu-item-icon">{{route.icon}}</v-icon>-->
                  <v-list-item-content>
                    <v-list-item-title class="app-menu-item-text pl-5" v-text="route.name" style="color: #e6dbdb"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="subRoute in route.subRoutes"
                  :key="subRoute.name"
                  @click="navClick(subRoute)"
                  active-class="border"
                  dark
                >

                  <!--<v-icon class="mx-4 app-menu-item-icon">{{subRoute.icon}}</v-icon>-->
                  <v-list-item-content>
                    <v-list-item-title class="app-menu-item-text pl-12">{{subRoute.name}}</v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
              </v-list-group>
              <v-divider style="border-width: medium 0 0 0 !important;"></v-divider>
            </template>
          </v-list>
        </div>

        <div class="nav-bottom nav-bottom-logo" style="bottom: 70px">
          <img class="nav-bottom-img" src="../../assets/autocrypt_mobility_logo_square_white.png" style="max-width:100px" alt="logo_bottom"/>
        </div>
        <div>
          <a class="nav-bottom py-4 font-weight-bold" href="https://113366.com/autocrypt" target="_blank" title="원격지원 링크"
             style="background-color: #212121 !important;">원격지원</a>
        </div>
      </div>
      <!--<div class="version white&#45;&#45;text">-->
      <!--<span>{{productVersion}}</span>-->
      <!--</div>-->
      <!--<div class="copyright white&#45;&#45;text">-->
      <!--Copyright, 2020 AUTOCRYPT All rights reserved.-->
      <!--</div>-->

    </v-navigation-drawer>
  </nav>
</template>
<script>
  // import Popup from './Popup.vue'
  import routes from '../../router/kst_routes';
  import dev_routes from '../../router/dev_routes';
  import { mask } from 'vue-the-mask';

  export default {
    directives: { mask },
    data: () => ({
      drawer: true,
      routes: [],
      currentPage: {},

      customerMobileNo: '',
      customerName: '',
      maskMobileNo: '####',
      productVersion: 'test',
    }),
    components: {
      // Popup
    },
    created() {
      let namuCenterId = 'namu-은평구청-n8IE1';
      let usageRoutes = routes.filter(item => !(item.type === 'hidden'));//todo app에서 나무센터 fix이므로 개발환경에서는 메뉴가 보여야함.
      const userInfo = this.$store.state.userInfo;
      const userRouteList = {
        categoryName: userInfo.categoryName,
        subRouteName: userInfo.subRouteName,
      }

      if (this.$store.state.centerInfo.centerId === namuCenterId) {
        usageRoutes = usageRoutes.filter(item => item.name !== '예약 접수' )
      }

      // 접근 가능 메뉴 리스트 필터링 (category[subRoute])
      usageRoutes = usageRoutes.filter(item => userRouteList.categoryName.includes(item.name));
      usageRoutes.forEach(item => {
        if(!!item.subRoutes) {
          item.subRoutes = item.subRoutes.filter(subItem => userRouteList.subRouteName.includes(subItem.name))
        }
      })


      this.routes = process.env.NODE_ENV === 'development'? [...dev_routes , ...usageRoutes]: usageRoutes;
      this.currentPage = this.$route;
    },
    mounted() {
      this.productVersion = process.env.VUE_APP_PACKAGE_VERSION
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    methods: {
      logout() {
        this.$api.logout().then((response) => {
          localStorage.removeItem('vuex');
          console.log('성공', response);
        }).catch(({response}) => {
          console.log('실패', response);
        });
        this.$router.push('/', async ()=> {
          await this.$func.clearSessionStorage();
          await location.reload();
        });
      },
      onMovePage() {
        const p = this.customerMobileNo? btoa(this.customerMobileNo): '';
        const n = this.customerName? encodeURI(this.customerName): '';
        window.location.href = `/TestReserve?p=${p}&n=${n}`

        // this.$router.push({path: 'TestReserve', query: {p: p, n:n}});
        // window.location.href = `/reserve/${this.customerMobileNo}`;
      },
      menuDisplayWithRole(route) {
        if(this.$store.state.userInfo.role === 'SA') {
          if(route.name !== '시스템 설정') {
            return 'd-none'
          }
        }
      },
      navClick(route) {
        this.currentPage = route;
        this.$router.push(route.path, (to, from) => {
          this.$func.clearComponentCache(to);
        });
      }
    }

  }
</script>
<style scoped>
  .border {
    /*border-radius: 4px;*/
    /*background-color: #e91e63 !important;*/
    color: #333333 !important;
    background-color: #3accba !important;
  }

  .app-navibar {
    /*top: 64px !important;*/
    background-color: #333333 !important;
    /*background-image: url('../assets/AUTOCRYPT_2U_Sidebar_BG3.png');*/
    /*background-size: cover;*/
  }

  .app-menu-group-item {
    background-color: #333333 !important;
  }

  .app-bar {
    /*left: 0px !important;*/
    color: black !important;
    box-shadow: 0 0 0 0 !important;

    border-style: solid;
    border-top: hidden;
    border-left: hidden;
    border-right: hidden;
    border-width: thin;
    border-bottom-color: #e6dbdb;
  }

  .app-bar__title {
    margin-top: 120px;
    margin-left: -10px;
    font-size: 21px;
    font-weight: bold;
    color: #515461;
  }

  .app-menu-logo-img {
    height: 30px;
    width: 30px;
  }

  .app-menu-logo-icon {
    color: #ff9117;
  }

  .app-menu-logo {
    color: #474250;
    font-size: 20px;
    text-align: center;
    margin: 15px 0px;
  }

  .app-menu-separator {
    border: solid;
    border-width: thin 0 0 0;
    border-color: hsla(0, 0%, 71%, .1);
    background-color: hsla(0, 0%, 71%, .5);
    margin: 10px 15px;
  }

  .app-menu-item {
    margin: 10px 10px;
    color: #535659;
  }

  .app-menu-item-icon {
    color: rgba(255,255,255,0.8);
  }
  .app-menu-item-text {
    font-weight: 400;
    font-size: 12px;
    /*color: rgba(255,255,255,0.8);*/
  }

  .version {
    font-size: 11px;
    position: fixed;
    width: 100%;
    text-align: center;
    bottom: 22px;
    color: #e6dbdb;
  }

  .copyright {
    font-size: 11px;
    position: fixed;
    width: 100%;
    text-align: center;
    bottom: 10px;
    color: #e6dbdb;
  }
  .nav-bottom {
    position: fixed;
    width: 100%;
    text-align: center;
    bottom:0px;
    text-decoration: none;
    font-size: 16px;
  }

  .list-item-group {
    position: fixed;
    width: 100%;
    top: 70px;
    overflow: hidden auto;
    bottom: 157px !important;
    /*scrollbar-*/
  }

  @media (max-width: 2000px) {
    .list-item-group {
      bottom: 150px !important;
    }

    .nav-bottom-logo {
      bottom: 65px !important;
    }

    .nav-bottom-img{
      width: 75% !important;
    }
  }

  /*스크롤바 두께*/
  ::-webkit-scrollbar {
    width: 7px;
  }

  /* 움직이는 영역 제외한 부분 */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 7px rgba(0,0,0,1);
    -webkit-border-radius: 7px;
    border-radius: 7px;
  }

  /*스크롤바 몸통 중 움직이는 영역*/
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 7px;
    border-radius: 7px;
    background: rgba(230,219,219,1);
    -webkit-box-shadow: inset 0 0 7px rgba(0,0,0,0.5);
  }
</style>
